export default __webpack_public_path__ + "static/media/GothaLig.400fc3b3.otf";